import { render, staticRenderFns } from "./CateAdd.vue?vue&type=template&id=00fb5f17&scoped=true"
import script from "./CateAdd.vue?vue&type=script&lang=js"
export * from "./CateAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fb5f17",
  null
  
)

export default component.exports